<template>
  <div class="hospitals-placeholder-card p-card p-component shadow-sm rounded-4 p-5 text-center mt-3">
    <div class="d-flex flex-column align-items-center justify-content-center py-5">
      <div class="icon-wrapper mb-4">
        <img
          :src="HospitalsIcon"
          alt="Hospitals Icon"
          class="hospitals-icon"
        />
      </div>
      <h3 class="fw-bold mb-2 title-text">قريباً... تبرعك للمستشفيات</h3>
      <p class="text-muted description-text">
        قريباً، ستتاح لك فرص التبرع لدعم المستشفيات وتوسيع أثر عطائك.
      </p>
    </div>
  </div>
</template>

<script>
import HospitalsIcon from "@/assets/icons/hospitals-icon.svg";

export default {
  name: "HospitalsPlaceholder",
  data() {
    return {
      HospitalsIcon,
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.hospitals-placeholder-card {
  background: $color-white;
  border-radius: 1.5rem !important;
  box-shadow: $box-shadow-case-card !important;
  min-height: 400px;
  max-width: 1065px;
  margin: 0 auto;
}

.icon-wrapper {
  background-color: $color-hospitals-placeholder-icon-bg;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hospitals-icon {
  width: 40px;
  height: 40px;
}

.title-text {
  color: $color-hospitals-placeholder-text;
}

.description-text {
  max-width: 500px;
  font-size: 1.1rem;
  line-height: 1.6;
}
</style>
